// Gallery manifest for Culture Diamond Jewels.
// Source media lives in public/assets/cd. Every image carries the Culture Diamond logo.
const gallery = [
  {
    id: "diamond",
    title: "Diamond Jewellery",
    description: "Natural diamond necklaces, pendants and solitaires.",
    grid: "/assets/cd/prod-neck-pear.jpg",
    posts: [
      { type: "image", src: "/assets/cd/prod-neck-pear.jpg" },
      { type: "image", src: "/assets/cd/prod-tennis-navy.jpg" },
      { type: "image", src: "/assets/cd/prod-ring-box.jpg" },
      { type: "image", src: "/assets/cd/prod-tennis-red.jpg" },
    ],
  },
  {
    id: "premium-cz",
    title: "Premium CZ",
    description: "Premium cubic zirconia rings, studs and everyday sparkle.",
    grid: "/assets/cd/prod-earrings.jpg",
    posts: [
      { type: "image", src: "/assets/cd/prod-earrings.jpg" },
      { type: "image", src: "/assets/cd/prod-chandelier.jpg" },
      { type: "image", src: "/assets/cd/prod-ring-xmas.jpg" },
      { type: "image", src: "/assets/cd/prod-rings-podium.jpg" },
      { type: "image", src: "/assets/cd/prod-ring-tree.jpg" },
    ],
  },
  {
    id: "worn",
    title: "On You",
    description: "Diamonds and CZ, styled and worn.",
    grid: "/assets/cd/model-black.jpg",
    posts: [
      { type: "image", src: "/assets/cd/model-black.jpg" },
      { type: "image", src: "/assets/cd/model-emerald.jpg" },
      { type: "image", src: "/assets/cd/model-hand.jpg" },
    ],
  },
];

export default gallery;
